import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

export const LaunchBulkUpdatePurchaseCurrencyCode = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const hasBulkUpdatePurchaseCurrencyFeature = useUserHasFeature(
    Feature.BulkUpdatePurchaseCurrency
  );

  if (!hasBulkUpdatePurchaseCurrencyFeature) {
    return null;
  }

  return (
    <>
      <PosDropdownItem
        key="update-purchases-currency-code"
        onClick={onClick}
        disabled={disabled}
      >
        <Stack gap="m" alignItems="center" width="full">
          <Content id={ContentId.BulkUpdatePurchaseCurrency} />
        </Stack>
      </PosDropdownItem>
    </>
  );
};
